import React from 'react';
import developmentGif from '../../assets/development.gif';

const QuoteCalculator = () => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: 'calc(100vh - 64px)',
      backgroundColor: '#fff',
    }}>
      <img src={developmentGif} alt="Loading..." style={{ width: '30%', height: '30%', objectFit: 'contain' }} />
    </div>
  );
};

export default QuoteCalculator;
